import { onTextInputRuleSet } from './Validation/rules/ruleSets/onTextInputRuleSet';
import { unmaskValue } from './utils/unmaskValue';
import { interstateInputEventBuilder } from '../InterstateEvents';
import { onTextInputMultilineSet } from './Validation/rules/ruleSets/onTextInputMultilineSet';
/**
 * Handles the onChange callback from the text input
 * Sets the value in state
 * Validates the value
 * Sets the validation state
 * Calls the consumers onChange callback if one is provided
 * @param setValue
 * @param onChangeCallback
 * @param validator
 * @param validationParameters
 */
export const handleOnTextChange = (setValue, onChangeCallback, validator, validationParameters) => event => {
  const unmaskedValue = unmaskValue(event.target.value, validationParameters.masking);
  // Textarea uses multiline rule set
  const ruleSet = validationParameters.multiline ? onTextInputMultilineSet : onTextInputRuleSet;
  // handle validation
  const validationState = validator.validate(unmaskedValue, validationParameters, ruleSet, true);

  // set the input value
  setValue(unmaskedValue);
  // call the onChange function
  if (onChangeCallback) {
    const interstateEvent = interstateInputEventBuilder(validationParameters.name, unmaskedValue, validationState.isValid, event, validationParameters.label, validationState.messageKey);
    onChangeCallback(interstateEvent);
  }
};